import React, { useState, Fragment } from 'react';
import { isPresent } from 'utils/helperMethods';
import { Tooltip as MuiTooltip, Typography, Modal, IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import Icon from 'sharedComponents/Icon';

import useScreen from 'hooks/useScreen';
import useStyles from './useStyles';

const Tooltip = props => {
  const { header, body, body2, body3, children, ...rest } = props;
  const classes = useStyles();
  const { isMobile } = useScreen();

  const [open, setOpen] = useState(false);

  const handleOpen = e => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = e => {
    e.stopPropagation();
    setOpen(false);
  };

  if (isMobile) {
    return (
      <Fragment>
        <div onClick={handleOpen} role="presentation">
          {children}
        </div>
        {open && (
          <Modal className={classes.modal} open onClose={handleClose}>
            <div className={classes.paper}>
              <div className={classes.header}>
                <Typography className={classes.headerText} variant="h2">
                  {header}
                </Typography>
                <IconButton onClick={handleClose}>
                  <Icon name="bigClose" />
                </IconButton>
              </div>
              {isPresent(body) && (
                <Typography className={classes.bodyText} variant="body2" color="inherit">
                  {body}
                </Typography>
              )}
              {isPresent(body2) && (
                <Typography className={classes.bodyText} variant="body2" color="inherit">
                  {body2}
                </Typography>
              )}
              {isPresent(body3) && (
                <Typography className={classes.bodyText} variant="body2" color="inherit">
                  {body3}
                </Typography>
              )}
            </div>
          </Modal>
        )}
      </Fragment>
    );
  }

  return (
    <MuiTooltip
      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
      {...rest}
      title={
        <Fragment>
          {isPresent(header) && (
            <Typography className={classes.headerText} variant="h2">
              {header}
            </Typography>
          )}
          {isPresent(body) && (
            <Typography className={classes.bodyText} variant="body2" color="inherit">
              {body}
            </Typography>
          )}
        </Fragment>
      }
    >
      {children}
    </MuiTooltip>
  );
};

Tooltip.propTypes = {
  header: PropTypes.string,
  body: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Tooltip.defaultProps = {
  header: '',
  body: '',
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/sharedComponents/Tooltip/Tooltip.js